import React from "react";
import { GOOGLE_MAP_EMBED_SRC } from "../constants/mapEmbed";

export function ContactSection() {
  return (
    <section className="section section-alt">
      <div className="section-inner contact-layout">
        <div className="contact-info">
          <header className="section-header section-header-left">
            <p className="section-eyebrow">Kontakt</p>
            <h1 className="section-title">Kontakt i lokacija</h1>
            <p className="section-subtitle">
              Pozovite nas za sve informacije o rezervacijama restorana, banket sale ili
              smeštaja. Naš tim će vas rado posavetovati i pomoći oko planiranja proslave.
            </p>
          </header>
          <div className="contact-details">
            <div>
              <h3>Telefon</h3>
              <a href="tel:034354571">034 354 571</a>
            </div>
            <div>
              <h3>Adresa</h3>
              <p>Kraljevačkog bataljona 267, Kragujevac</p>
            </div>
            <div className="contact-details-hours">
              <h3>Radno vreme</h3>
              <p>Pon–Sub: 09–23 h</p>
              <p>Nedelja: 10–22 h</p>
            </div>
          </div>
          <a
            href="tel:034354571"
            className="btn btn-primary btn-full contact-call-btn"
          >
            POZOVITE NAS
          </a>
        </div>
        <div className="bottom-contact-map">
          <div className="map-wrapper" aria-label="Mapa RESTORAN KRČMA">
            <iframe
              title="Mapa RESTORAN KRČMA"
              src={GOOGLE_MAP_EMBED_SRC}
              width="600"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

